export default __webpack_public_path__ + "static/media/detail_big_14_2.47a56a81.jpg";